import { gql } from "@urql/core";

import { mutation } from "@/services/lukita";

export default function setupAccountMutation({
  name,
  priceId,
  successUrl,
  cancelUrl,
}) {
  return mutation(
    gql`
      mutation SetupAccountMutation($input: SetupAccountInput!) {
        setupAccount(input: $input) {
          user {
            __typename
          }
          checkoutUrl
        }
      }
    `,
    { input: { name, priceId, successUrl, cancelUrl } },
  );
}
